<template>
  <div class="category-nav-page">
    <category-navigation />
  </div>
</template>

<script>
import CategoryNavigation from '@/components/category-navigation.vue';

export default {
  name: 'CategoryNav',
  components: { CategoryNavigation }
};
</script>

<style lang="scss" scoped>
.category-nav-page {
  min-height: 100vh;
  background: #f5f7fa;
}
</style>
